// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router';
import VueResource from 'vue-resource';
import store from './store';
import { CHANNEL_MARKING } from './config';

Vue.use(VueResource);
Vue.http.options.emulateJSON = true;
Vue.http.options.xhr = {withCredentials: true};
Vue.http.interceptors.push(function(request, next) {//拦截器
    request.credentials = true; // 跨域携带cookie
    // request.headers.set('appsource', '' + CHANNEL_MARKING); // 增加M站的渠道标识；因M站与IOS使用同一接口，来区分M站、ios、及小程序
    next();
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js